import React from 'react';
import { Icon } from 'Permafrost/index';
import { StyledAppTitle } from './AppTitle.styles';
export const AppTitle = (props) => {
    const { actions, className, icon, id, title } = props;
    return (React.createElement(StyledAppTitle, { className: className, "data-cy": props['data-cy'], id: id },
        icon && React.createElement(Icon, { name: icon, className: "appIcon" }),
        React.createElement("h3", null, title),
        actions && React.createElement("span", { className: "ActionLinks" }, actions)));
};
//# sourceMappingURL=AppTitle.js.map